module.exports = __webpack_public_path__ + "static/media/manzate_max.946e0073.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/curativa/manzate_max.png
// module id = 2112
// module chunks = 3